// 导航配置
// 默认显示导航
/*
 * system ：系统类型，0：计费系统，1：机房系统，2：末端控制
 */ 

const DefaultMenu = [
    {
        icon: 'icon-shouye',
        path: '/home',
        title: 'home',
        id: "1",
        system: [0, 2],
    }, {
        icon: 'icon-dangan2',
        title: 'constructionMana',
        id: "2",
        system: [0, 2],
        subs: [
            {
                path: '/residence',
                title:'addConstruction',
                id: "2-1",
                role: 'house',
                system: [0, 1, 2],
            },
            {
                path: '/meter',
                title: 'meterBinding',
                id: "2-2",
                role:'terminal_device',
                system: [0, 1, 2],
            },
            {
                path: '/household',
                title: 'householdMana',
                id: "2-3",
                role: 'business_owner',
                system: [0, 1, 2],
            },
            {
                path: '/setchargescheme',
                title: 'chargescheme',
                id: "2-4",
                disabled: false,
                role: 'business_owner',
                system: [0],
            },
        ]
    }, {
        icon: 'icon-shebei',
        title: 'equipmentMana',
        id: "3",
        system: [0, 2],
        subs: [
            // 集控器管理
            {
                path: '/gateway',
                title:'gatewayMana',
                id: "3-1",
                role: 'collector',
                system: [0, 2],
            },
			// 直连设备管理
			{
			    path: '/directly',
			    title: 'directlyMana',
			    id: "3-7",
			    role: 'tDeviceManage',
			    system: [2],
			},
            // // 设备参数
            // {
            //     path: '/fancoil-add',
            //     title: 'plateMana',
            //     id: "3-2",
            //     role: 'device_parameters',
            //     system: [0],
            // },
            // 设备控制 计费系统
            {
                path: '/equipmentControl',
                title: 'plateMana',
                id: "3-3",
                role: 'device_control',
                system: [0],
            },
            // 设备控制 群控系统
            {
                path: '/equipmentControl1',
                title: 'equipmentControl',
                id: "3-6",
                role: 'device_control',
                system: [2],
            },
            // 设备监控
            {
                path: '/terminalcontrollist',
                title: 'terminalcontrollist',
                id: "3-4",
                role: 'collector',
                disabled: false,
                system: [2],
            },
            // 设备故障
            {
                path: '/devicefault',
                title: 'devicefault',
                id: "3-5",
                role: 'collector',
                disabled: false,
                system: [0, 2],
            },
        ]
    }, {
        icon: 'icon-yiqikongzhi',
        title: 'chaokongMana',
        id: "7",
        system: [2],
        subs: [
            // 设备分组
            {
                path: '/equipment',
                title: 'equipmentGroup',
                id: "7-1",
                role: 'device_control',
                system: [0, 2],
            },
            // 报警设置
            // {
            //     path: '/alarmset',
            //     title: 'alarmset',
            //     id: "7-2",
            //     disabled: true,
            //     role: 'time_control',
            //     system: [0, 2],
            // },
            // 群控管理 计费系统
            {
                path: '/clustermana',
                title: 'clustermana',
                id: "7-3",
                role: 'device_control',
                system: [0],
            },
            // 群控管理  控制系统
            {
                path: '/clustermana1',
                title: 'clustermana',
                id: "7-8",
                role: 'device_control',
                system: [2],
            },
            // 计费模式
            {
                path: '/billingmode',
                title: 'billingmode',
                id: "7-7",
                role: 'device_control',
                system: [0],
            },
            // 定时管理
            {
                path: '/timing',
                title: 'timing',
                id: "7-4",
                disabled: false,
                role: 'time_control',
                system: [0, 2],
            },
            // 欠费管理
            {
                path: '/arrearagemana',
                title: 'arrearagemana',
                id: "7-5",
                disabled: true,
                role: 'business_owner',
                system: [0],
            },
            // 运行状态
            // {
            //     path: '/running',
            //     title: 'running',
            //     id: "7-6",
            //     disabled: true,
            //     role: 'device_control',
            //     system: [0, 2],
            // },
        ]
    }, {
        icon: 'icon-shoufeiguanli',
        title: 'systemSetting',
        id: "4",
        system: [0],
        subs: [
            // 抄读结算
            {
                path: '/readingmeter',
                title: 'readingmeter',
                id: "4-1",
                disabled: false,
                role: 'balance',
                system: [0],
            },
            // 费用打印
            {
                path: '/chargeprint',
                title: 'chargeprint',
                id: "4-2",
                disabled: false,
                role: 'balance',
                system: [0],
            },
        ]
    }, {
        icon: 'icon-baobiaotongji',
        title: 'setteleMana',
        id: "5",
        system: [0],
        subs: [
            {
                path: '/usestatement',
                title: 'residentDosage',
                id: "5-1",
                disabled: false,
                role: 'report',
            },
            {
                path: '/receivablestatement',
                title: 'receivablestatement',
                id: "5-2",
                disabled: false,
                role: 'report',
            },
            {
                path: '/paystatement',
                title: 'paystatement',
                id: "5-3",
                disabled: false,
                role: 'report',
            },
			// {
			//     path: '/historyreport',
			//     title: 'historyreport',
			//     id: "5-4",
			//     disabled: false,
			//     role: 'report',
			// }
        ]
    }, {
        icon: 'icon-xitongshezhi1',
        title: 'roleSetting',
        id: "6",
        system: [0, 2],
        subs: [
            // 账号管理
            {
                path: '/role',
                title: 'role',
                id: "6-1",
                disabled: false,
                role: 'system',
                system: [0, 2],
            },
            // 权限控制
            {
                path: '/authority',
                title: 'authority',
                id: "6-2",
                disabled: false,
                role: 'system',
                system: [0, 2],
            },
            // 日志管理
            {
                path: '/logmanage',
                title: 'logmanage',
                id: "6-3",
                disabled: false,
                role: 'account',
                system: [0, 2],
            },
			// 日志管理
			{
			    path: '/aftersales',
			    title: 'aftersales',
			    id: "6-4",
			    disabled: false,
			    role: 'account',
			    system: [0, 2],
			},
        ]
    }, 
	//个人中心
	{
        icon: 'icon-gerenzhongxin',
        title: 'userCenter',
        id: "8",
        subs: [
            // {
            //     path: '/personalsetting',
            //     title: 'personalsetting',
            //     id: "8-1",
            //     disabled: true,
            //     role: '',
            //     system: [0, 2],
            // },
            {
                path: '/message',
                title: 'messageCenter',
                id: "8-2",
                disabled: false,
                role: '',
                system: [0, 2],
            },
            {
                path: '/changepassword',
                title: 'changePassword',
                id: "8-3",
                disabled: false,
                role: '',
                system: [0, 2],
            },
			{
			    path: '/usercenter',
			    title: 'userEmail',
			    id: "8-4",
			    disabled: false,
			    role: '',
			    system: [0, 2],
			},
        ]
    },
];

// 异步添加导航栏
const AsyncMenu = [
    // {
    //     icon: 'icon-ico_xitongshezhi_shebeixinxiweihu',
    //     path: '/admin',
    //     title: 'admin',
    //     id: "9",
    // }
]

// admin导航

const AdminMenu = [
    {
        icon: 'icon-shouye',
        path: '/admin',
        title: 'home',
        id: "10",
    },
    {
        icon: 'icon-xiangmuleixing',
        path: '/projecttypesetting',
        title: 'projecttypesetting',
        id: "10-1",
    },
    // 计费规则
    // {
    //     icon: 'icon-fanganzhiding-copy',
    //     path: '/chargeschemelist',
    //     title: 'chargeschemelist',
    //     id: "10-2",
    // },
    // 账号管理
    {
        icon: 'icon-weibiaoti5',
        path: '/companyMana',
        title: 'companyMana',
        id: "10-3",
    },
    // 权限模块
    {
        icon: 'icon-quanxianguanli',
        path: '/roleModule',
        title: 'roleModule',
        id: "10-4",
    },
    {
        icon: 'icon-shezhi',
        path: '/dictionary',
        title: 'dictionary',
        id: "10-5",
    }, 
    {
        icon: 'icon-shezhi',
        path: '/sysdic',
        title: 'sysdic',
        id: "10-6",
    },
]

// 机房系统导航
const MachineMenu = [
    // 机房监控
    {
        icon: 'icon-shouye',
        path: '/machineHome',
        title: 'home',
        id: "30",
        role: 'machine',
		system:[1],
    },
    // 机房监控
    {
        icon: 'icon-jiankong',
        path: '/machinemana/0',
        title: 'machinemana',
        id: "20",
        role: 'machine',
		system:[1,3],
    },
    // 节能概况
    {
        icon: 'icon-jiankonggaikuang_huaban',
        title: 'EnergySituation',
        id: "50",
		system:[1],
        subs: [
            // 节能概况
            {
                path: '/EnergySituation',
                title: 'EnergySituationset',
                id: "50-1",
                role: 'energy_stuation',
				system:[1],
            },
            // 系统节能
            {
                path: '/EnergySystem',
                title: 'EnergySystem',
                id: "50-2",
                role: 'energy_system',
				system:[1],
            },
            // 水泵节能
            {
                path: '/EnergyPump',
                title: 'EnergyPump',
                id: "50-3",
                role: 'energy_pump',
				system:[1],
            },
            // 水泵节能列表
            {
                path: '/EnergyPumpList',
                title: 'EnergyPumpList',
                id: "50-4",
                role: 'energy_pump',
				system:[1],
            },

        ]
    },
    // 设备管理
    {
        icon: 'icon-shebei',
        title: 'equipmentMana',
        id: "27",
        role: 'collector',
		system:[1,3],
        subs: [
            // 集控器管理
            {
                path: '/machinegateway',
                title: 'gatewayMana',
                id: "27-1",
                role: 'collector',
				system:[1,3]
            },
            // 变量管理
            {
                path: '/argmana',
                title: 'argmana',
                id: "27-2",
                role: 'collector',
				system:[1,3],
            },
        ]
    }, 
    // 设备工况
    // {
    //     icon: 'icon-ecs-running',
    //     path: '/devicestatus',
    //     title: 'machineDeviceStatus',
    //     id: "21",
    //     disabled: false,
    // },
    // 故障记录
    {
        icon: 'icon-guzhangguanli',
        path: '/faultlist',
        title: 'faultlist',
        id: "22",
        disabled: false,
		system:[1,3],
    },
    // // 数据曲线
    // {
    //     icon: 'icon-quxiantu',
    //     path: '/deviceCurve',
    //     title: 'deviceCurve',
    //     role: "device_report",
    //     id: "26",
    //     disabled: false,
    // },
    // 数据报表
    {
        icon: 'icon-yunxingrizhi',
        path: '/deviceReport',
        title: 'deviceReport',
        role: "device_report",
        id: "23",
		system:[1,3],
        disabled: false,
		
    },
    // 参数设置
    {
        icon: 'icon-shezhi',
        path: '/argsetting',
        title: 'argSetting',
        role: "argsetting",
        id: "25",
		system:[1,3],
        disabled: false,
        subs: [
            // 温度设置
            {
                path: '/tempsetting',
                title: 'tempsetting',
                id: "25-1",
                role: 'tempsetting',
				system:[1,3],
            },
            // 压力设置
            {
                path: '/pressuresetting',
                title: 'pressuresetting',
                id: "25-2",
                role: 'pressuresetting',
				system:[1,3],
            },
            // 延时设置
            {
                path: '/delayedsetting',
                title: 'delayedsetting',
                role: "delayedsetting",
                id: "25-3",
                disabled: false,
				system:[1,3],
            },
            // 频率设置
            {
                path: '/frequencysetting',
                title: 'frequencysetting',
                role: "frequencysetting",
                id: "25-4",
                disabled: false,
				system:[1,3],
            },
            // 高级参数设置
            {
                path: '/advanceArgsetting',
                title: 'advanceArgsetting',
                role: "advancedArgsetting",
                id: "31",
                disabled: false,
				system:[1,3],
            },
        ]
    },
    
    // 基础配置
    {
        icon: 'icon-xitongshezhi1',
        title: 'basesetting',
        id: "40",
		system:[1,3],
        subs: [
            // 能源设置
            {
                path: '/energybase',
                title: 'energybase',
                id: "40-1",
                role: 'energybase',
				system:[1],
            },
            // 报表设置
            {
                path: '/serverroom',
                title: 'deviceReportsetting',
                id: "40-2",
                role: 'energybase',
				system:[1,3],
            },
        ]
    },
    
    // 定时管理
    {
        icon: 'icon-dingshi',
        path: '/timerMana',
        title: 'timerMana',
        role: "time_control",
        id: "24",
        disabled: false,
		system:[1,3],
    },
    // // 日志管理
    // {
    //     icon: 'icon-xitongshezhi1',
    //     path: '/log',
    //     title: 'log',
    //     id: "28",
    //     disabled: false,
    // },
    {
        icon: 'icon-xitongshezhi1',
        title: 'roleSetting',
        id: "29",
		system:[1,3],
        subs: [
            // 账号管理
            {
                path: '/role1',
                title: 'role',
                role: "system",
                id: "29-1",
				system:[1,3],
            },
            // 权限控制
            {
                path: '/authority1',
                title: 'authority',
                role: "system",
                id: "29-2",
				system:[1,3],
            },
            // 日志管理
            {
                icon: 'icon-xitongshezhi1',
                path: '/log',
                title: 'log',
                role: "system",
                id: "29-3",
				system:[1,3],
            },
			// 售后服务
			{
			    path: '/aftersales1',
			    title: 'aftersales',
			    id: "29-4",
			    disabled: false,
			    role: 'system',
			    system: [1, 3],
			},
        ]
    },
	//个人中心
	{
	    icon: 'icon-gerenzhongxin',
	    title: 'userCenter',
	    id: "8",
		system: [1, 3],
	    subs: [
	        // {
	        //     path: '/personalsetting',
	        //     title: 'personalsetting',
	        //     id: "8-1",
	        //     disabled: true,
	        //     role: '',
	        //     system: [0, 2],
	        // },
	        {
	            path: '/message1',
	            title: 'messageCenter',
	            id: "8-2",
	            disabled: false,
	            role: '',
	            system: [1, 3],
	        },
	        {
	            path: '/changepassword1',
	            title: 'changePassword',
	            id: "8-3",
	            disabled: false,
	            role: '',
	            system: [1, 3],
	        },
			{
			    path: '/usercenter1',
			    title: 'userEmail',
			    id: "8-4",
			    disabled: false,
			    role: '',
			    system: [1, 3],
			},
	    ]
	},
]

export {
    DefaultMenu,
    AsyncMenu,
    AdminMenu,
    MachineMenu,
}